// src/utils/logger.js

/**
 * Centralized Logging Utility
 *
 * Respects DEBUG_MODE environment variable and provides consistent logging
 * across the application. In production, only errors are logged.
 */

// Force DEBUG_MODE to false in production
const DEBUG_MODE = false; // process.env.REACT_APP_DEBUG_MODE === 'true';

class Logger {
  constructor(context = 'App') {
    this.context = context;
  }

  /**
   * Debug-level logging - only shows when DEBUG_MODE is enabled
   */
  debug(...args) {
    if (DEBUG_MODE) {
      console.log(`[${this.context}]`, ...args);
    }
  }

  /**
   * Info-level logging - only shows when DEBUG_MODE is enabled
   */
  info(...args) {
    if (DEBUG_MODE) {
      console.info(`[${this.context}]`, ...args);
    }
  }

  /**
   * Warning-level logging - only shows when DEBUG_MODE is enabled
   */
  warn(...args) {
    if (DEBUG_MODE) {
      console.warn(`[${this.context}]`, ...args);
    }
  }

  /**
   * Error-level logging - always shows (even in production)
   */
  error(...args) {
    console.error(`[${this.context}]`, ...args);
  }

  /**
   * Create a logger with a specific context
   */
  withContext(context) {
    return new Logger(context);
  }
}

// Export singleton instance
export default new Logger('App');

// Export class for creating contextualized loggers
export { Logger };
